'use strict';

angular.module('app')
  .service('SearchDR', function ($http, $timeout, $location, $q, $routeParams, config, info, utils, Request) {
    var spCounter = 1,
      DOpromise;
    return {
      getShopList: function (location, filter, pageNum) {
        angular.extend(filter, pageNum);

        return Request.get('search/' + location.model.toLowerCase() + '/' + location.pk + '/resorts/', filter).then(function (res) {
          if (utils.setNoIndex) {
            utils.setNoIndex(res.data.count !== 0 ? true : false);
          }

          if (utils.setPrevNextUrl) {
            utils.setPrevNextUrl(pageNum.page, res.data.next); 
          }

          return res.data;
        }).catch(function(error) {
          if (utils.setNoIndex) {
            utils.setNoIndex(true);
          }
          
          if (error.status == '404') {
            check404.checkUrlStatus();
          }

          return {
            count: 0,
            results: []
          }
        })
      },
      getMapInfo: function (bounds, filter) {
        var localCounter = spCounter;

        if (DOpromise) {
          DOpromise.resolve(false);
        }

        DOpromise = $q.defer();
        Request.get('search/resorts/geo/', angular.extend(bounds, filter), false, DOpromise).then(function (res) {
          if (localCounter === spCounter - 1) {
            var markers = [];

            _.each(res.data, function (val) {
              if (val.latitude && val.longitude) {
                markers.push({
                  lat: val.latitude,
                  lng: val.longitude,
                  icon: config.mapIcons.withPrice,
                  info: val,
                  group: "events"
                });
              }
            });

            DOpromise.resolve(markers);

          } else {
            DOpromise.reject('data is no more actual');
          }
        });
        
        spCounter += 1;

        return DOpromise.promise;
      },
      getShopDetailInfo: function (id, filters) {
        return Request.get('search/resort/' + id + '/', filters).then(function (res) {
          return res.data;
        })
      },
      triggerMap: function () {
        return document.querySelector('.go-to-map').click();
      },
      getLocationDetails: function (location, filter) {
        var data = _.clone(filter);
        if (data) {
          // data.price_sum_0 = undefined;
          // data.price_sum_1 = undefined;
        }
        
        return Request.get('search/'+ location.model.toLowerCase()  + '/' + location.pk + '/resorts-info/', data).then(function (res) {
          return res.data;
        });
      }
    };
  });